import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";

const SIDEBAR_OFFSET_PATHS = ["/apps/file-manager", "/apps/email", "/apps/calendar"];

export default function Main() {
  const { pathname } = useLocation();

  useEffect(() => {
    const bc = document.body.classList;
    if (SIDEBAR_OFFSET_PATHS.includes(pathname)) {
      bc.add("sidebar-offset");
    } else {
      bc.remove("sidebar-offset");
    }
    bc.remove("sidebar-show");
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <React.Fragment>
      <Sidebar />
      <Outlet />
    </React.Fragment>
  )
}